export default __webpack_public_path__ + "static/media/i242hp.276816c5.webp";